<label for="city" *ngIf="label">{{ label }}</label>

<!-- -->
<ng-select (change)="onSelectChange($event?.name)" class="form-control" [items]="filteredItems" bindLabel="name"
  [searchFn]="customSearchFn.bind(this)" bindValue="name" [(ngModel)]="value"
  style="padding: 0; width: 100%; height: 100%; border-radius: 6px !important; border: none;">

  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
    <div class="d-flex justify-content-between my-auto">
      <h6 class="mb-0" [ngOptionHighlight]="search">
        {{ item.name }}
      </h6>
    </div>
  </ng-template>

  <!-- Message affiché automatiquement si aucun résultat n'est trouvé -->
  <ng-template ng-notfound-tmp *ngIf="noResults">
    <div class="d-flex justify-content-between my-auto p-2" style="background-color: #ebf5ff; cursor: pointer;">
      <h6 class="mb-0">
        Merci de choisir une gouvernorat
      </h6>
    </div>
  </ng-template>

</ng-select>